import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { Configuration } from './config';
import { of } from 'rxjs';
import { LoaderService } from '../components/loader/loader.service';
@Injectable({ providedIn: 'root' })
export class HttpService {
  //public
  serviceData: any;
  method: any;
  url: string;
  data: any;
  errorMessage: any;
  callBack: (res: any) => any;

  superUserToken: string;
  isSuperUserReq: boolean = false;

  listSucces = [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210]
  token = environment.apiToken
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient,
    private loader: LoaderService) {

  }

  createAuthorizationHeader(headers: Headers, customToken: string = null) {
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    headers.set('X-URL', window.location.hash);
    headers.set('X-AUTH-TOKEN', this.token);
    headers.set('X-USER-CREATE', 'Qure');

  }
  get(url, callBack: (res: any) => any = null, auth: boolean = false, tokenSuper: string = null) {

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('X-AUTH-TOKEN', this.token);
    this.showLoader();

    return this._http.get(Configuration.get().apiBackend + url
      , { headers: headers, withCredentials: false }
    )
      .pipe(map((res: any) => {

        if (callBack !== undefined && callBack !== null) {
          callBack(res);
        }
        return res;
      })
        , catchError(error => {
          this.handleError(error);
          return of([]);
        })
        , finalize(() => {
          this.hideLoader();
        })
      )
  }
  post(url, data, callBack: (res: any) => any = null, auth: boolean = false, tokenSuper: string = null) {

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('X-AUTH-TOKEN', this.token);
    this.showLoader();


    return this._http.post(Configuration.get().apiBackend + url, data
      , { headers: headers, withCredentials: false }
    )
      .pipe(map((res: any) => {
        this.responseSuccess(res)
        if (callBack !== undefined && callBack !== null) {
          callBack(res);
        }
        return res;
      })
        , catchError(error => {
          this.handleError(error);
          return of([]);
        })
        , finalize(() => {
          this.hideLoader();
        })
      )
  }
  postNonMessage(url, data, callBack: (res: any) => any = null, auth: boolean = false, tokenSuper: string = null) {

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('X-AUTH-TOKEN', this.token);
    this.showLoader();


    return this._http.post(Configuration.get().apiBackend + url, data
      , { headers: headers, withCredentials: false }
    )
      .pipe(map((res: any) => {
        // this.responseSuccess(res)
        if (callBack !== undefined && callBack !== null) {
          callBack(res);
        }
        return res;
      })
        , catchError(error => {
          // this.handleError(error);
          return of([]);
        })
        , finalize(() => {
          this.hideLoader();
        })
      )
  }
  private responseSuccess(res: Response | any) {

    if (this.listSucces.includes(res.status)) {
      let message = res.message
      if (message) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: message,
          confirmButtonText: 'OK'
        });

      } else {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Data berhasil disimpan',
          confirmButtonText: 'OK'
        });

      }
    }
  }
  private handleError(error: Response | any) {
    // console.log(error);
    if (error.status == 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Peringatan',
        text: 'Maaf, koneksi ke server terputus, silahkan coba lagi.',
        confirmButtonText: 'OK'
      });
      // this.alert.warn('Peringatan', 'Maaf, koneksi ke server terputus, silahkan coba lagi.');

    } else if (error.status == 500) {

      if (error._body == '') {
        this.errorMessage = {};
        let errorText = 'Error tidak diketahui';
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: errorText,
          confirmButtonText: 'OK'
        });


      } else {
        this.errorMessage = JSON.parse(error._body)
        // let errorText = '';
        // for (let i = 0; i < this.errorMessage.errors.length; i++) {
        //   errorText += this.errorMessage.errors[i].error;
        // }
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: this.errorMessage.message,
          confirmButtonText: 'OK'
        });

      }

    } else if (error.status == 401) {
      if (error.headers.get('RequireSupervisor') == 'true') {

      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Tidak punya hak akses, silahkan coba login ulang atau hubungi administrator',
          confirmButtonText: 'OK'
        });
      }
    } else if (error.status == 403) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Maaf, sesi sudah berakhir, silahkan login ulang.',
        confirmButtonText: 'OK'
      });

    } else if (error.status == 404) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Maaf, halaman API tidak ditemukan.',
        confirmButtonText: 'OK'
      });

    } else if (error.status == 503 || error.status == 504) {
      Swal.fire({
        icon: 'warning',
        title: 'Peringatan',
        text: 'Maaf, server time out, tidak dapat melayani permintaan. Silahkan Ulangi.',
        confirmButtonText: 'OK'
      });

    } else if (error.status == 400 || error.status == 400) {
      if (JSON.parse(error._body).batal !== undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: JSON.parse(error._body).message,
          confirmButtonText: 'OK'
        });

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: JSON.parse(error._body).message,
          confirmButtonText: 'OK'
        });

      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
        confirmButtonText: 'OK'
      });
    }

  }
  showLoader(): void {
    this.loader.show();
  }

  hideLoader(): void {
    this.loader.hide();
  }
  private reject() {
    return Promise.reject('koneksi terputus');
  }

  //   
}
